<script setup lang="ts">
/**
 * TieIcon – eigenes Inline-SVG für die Bindebogen-Aktion (Tie/Slur).
 *
 * Zeigt zwei ausgefüllte Notenköpfe, verbunden durch einen prominenten Bogen darüber – die klassische
 * Notations-Darstellung eines Binde-/Legatobogens (klarer als das frühere `fa6-solid:link`). Bewusst
 * bold & minimal (kräftige Köpfe, deutlicher Bogen, keine Notenhälse), damit es auf den ~14 px großen
 * Toolbar-Buttons lesbar bleibt.
 *
 * Single-Root-`<svg>` mit `width/height=1em` (matcht die `fa6-solid:*`-Nachbarn) und `currentColor`,
 * damit es die Button-Textfarbe UND `disabled:opacity-30` erbt. `class` fällt automatisch durch.
 */
</script>

<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
  >
    <circle cx="6" cy="18" r="3.4"/>
    <circle cx="18" cy="18" r="3.4"/>
    <path
        d="M5 13 Q12 5 19 13"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
    />
  </svg>
</template>
